import * as Bixby from '$/core';

export interface SettingsState {
  settings?: Bixby.Models.Settings;
  error?: Bixby.Models.BixbyError;
  isLoading: boolean;
  disclaimerAcknowledged: boolean;
  dataSiteHosts?: Bixby.Models.DataSiteHost[];
}

export const SETTINGS_INPROGRESS = 'SETTINGS_INPROGRESS';
export const SETTINGS_SUCCESS = 'SETTINGS_SUCCESS';
export const SETTINGS_FAILURE = 'SETTINGS_FAILURE';
export const DISCLAIMER_ACKNOWLEDGED = 'DISCLAIMER_ACKNOWLEDGED';
export const DISCLAIMER_INVALIDATE_ACKNOWLEDGED = 'DISCLAIMER_INVALIDATE_ACKNOWLEDGED';
export const DISCLAIMER_PREVIOUSLY_ACKNOWLEDGED = 'DISCLAIMER_PREVIOUSLY_ACKNOWLEDGED';
export const DATASITEHOST_INPROGRESS = 'DATASITEHOST_INPROGRESS';
export const DATASITEHOST_FAILURE = 'DATASITEHOST_FAILURE';
export const DATASITEHOST_SUCCESS = 'DATASITEHOST_SUCCESS';
export const CREATE_DATASITEHOST = 'CREATE_DATASITEHOST';
export const CREATE_DATASITEHOST_FAILURE = 'CREATE_DATASITETOST_FAILURE';
export const CREATE_DATASITEHOST_SUCCESS = 'CREATE_DATASITEHOST_SUCCESS';

interface SettingsInProgress extends Bixby.Models.BixbyAction<undefined, typeof SETTINGS_INPROGRESS> {
  type: typeof SETTINGS_INPROGRESS;
}
interface SettingsSuccess extends Bixby.Models.BixbyAction<Bixby.Models.Settings, typeof SETTINGS_SUCCESS> {
  type: typeof SETTINGS_SUCCESS;
  payload: Bixby.Models.Settings;
}
interface SettingsFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof SETTINGS_FAILURE> {
  type: typeof SETTINGS_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface DisclaimerAcknowledged extends Bixby.Models.BixbyAction<boolean, typeof DISCLAIMER_ACKNOWLEDGED> {
  type: typeof DISCLAIMER_ACKNOWLEDGED;
}
interface DisclaimerInvalidateAcknowledged
  extends Bixby.Models.BixbyAction<boolean, typeof DISCLAIMER_INVALIDATE_ACKNOWLEDGED> {
  type: typeof DISCLAIMER_INVALIDATE_ACKNOWLEDGED;
}

interface DisclaimerPreviouslyAcknowledged
  extends Bixby.Models.BixbyAction<boolean, typeof DISCLAIMER_PREVIOUSLY_ACKNOWLEDGED> {
  type: typeof DISCLAIMER_PREVIOUSLY_ACKNOWLEDGED;
}

interface DataSiteHostInProgress extends Bixby.Models.BixbyAction<undefined, typeof DATASITEHOST_INPROGRESS> {
  type: typeof DATASITEHOST_INPROGRESS;
}
interface DataSiteHostSuccess extends Bixby.Models.BixbyAction<Bixby.Models.DataSiteHost[], typeof DATASITEHOST_SUCCESS> {
  type: typeof DATASITEHOST_SUCCESS;
  payload: Bixby.Models.DataSiteHost[];
}
interface DataSiteHostFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof DATASITEHOST_FAILURE> {
  type: typeof DATASITEHOST_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface CreateDataSiteHost extends Bixby.Models.BixbyAction<undefined, typeof CREATE_DATASITEHOST> {
  type: typeof CREATE_DATASITEHOST;
}
interface CreateDataSiteHostSuccess extends Bixby.Models.BixbyAction<Bixby.Models.DataSiteHost[], typeof CREATE_DATASITEHOST_SUCCESS> {
  type: typeof CREATE_DATASITEHOST_SUCCESS;
  payload: Bixby.Models.DataSiteHost[];
}
interface CreateDataSiteHostFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof CREATE_DATASITEHOST_FAILURE> {
  type: typeof CREATE_DATASITEHOST_FAILURE;
  payload: Bixby.Models.BixbyError;
}

export type SettingsActionTypes =
  | SettingsInProgress
  | SettingsSuccess
  | SettingsFailure
  | DisclaimerAcknowledged
  | DisclaimerInvalidateAcknowledged
  | DisclaimerPreviouslyAcknowledged
  | DataSiteHostInProgress
  | DataSiteHostSuccess
  | DataSiteHostFailure
  | CreateDataSiteHost
  | CreateDataSiteHostSuccess
  | CreateDataSiteHostFailure;
